import styled from 'styled-components';

const Checkbox = styled.input.attrs(() => ({
    type: 'checkbox',
    className: 'form-checkbox cursor-pointer',
}))``;

export default Checkbox;
